import React, { useState, useEffect, useRef } from "react";
import * as API from '../../../framework/API/api';
import { utility } from "../../../framework/utility/utilityProvider";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid, GridColumn, GridNoRecords, getSelectedState, GridToolbar } from '@progress/kendo-react-grid';
import { useTranslation } from "../../../locale/useTranslation";
import ToastNotification from "../../../components/ToastNotification";
import { COLUMNSTYPE, ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, LOGEVENT, MAM_STATUS, MODULE, TOAST_TYPES, TRANSMISSION_ACTION, TRANSMISSION_ACTIVE_STATUS } from "../../../framework/constant/constant";
import ActionButton from "../../../framework/forms/helpercomponents/buttons/ActionButton";
import RoundButton from "../../../framework/forms/helpercomponents/buttons/RoundButton";
import MyStatusCell from "../../../components/MyStatusCell";
import MAMStatusCell from "../../../components/MAMStatusCell";
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from "../../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { TimeCell } from "../../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { ArrayCell } from "../../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import { TransmissionTypeStatusCell } from "../../../components/TransmissionTypeStatusCell";
import moment from "moment";
import { MenuCommandCell } from '../../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ';
import { collectionMenuModelVODReport } from "../../../framework/forms/helpercomponents/contextMenu/menus/collectionMenuModel";
import { ContextMenu } from 'primereact/contextmenu';
const VODActivityReport = () => {

    const currentDate = Date.now()
    const previousDate = moment(new Date(currentDate)).subtract(1, 'days').format("YYYY-MM-DD")
    const lang = useTranslation();

    const blankDataItem = {
        fromDate: previousDate,
        toDate: previousDate,
        hasNoTransmission: false,
        isTxReady: false
    }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [thumbnailData, setThumbnailData] = useState([]);
    const [transmissionData, setTransmissionData] = useState([]);
    const [tabNumber, setTabNumber] = React.useState("1");
    const [loadingStatus, setLoadingStatus] = useState(lang.no_record_found_error_message);
    const [dataColumns, setDataColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [pendingTransmissionData, setPendingTransmissionData] = useState([]);
    
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedState, setSelectedState] = useState({});
    const DATA_ITEM_KEY = '_id';
    const idGetter = (dataItem) => dataItem[DATA_ITEM_KEY];
    const menuRef = useRef(null);
    const onChange = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setDataItem({ ...dataItem, [e.target.name]: value });
    };
    const userData = utility.getValue(LOCALSTORAGE_KEY.userData);

    useEffect(() => {
        loadGridColumns();
    }, []);

    const loadGridColumns = async () => {
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);

        const columns = await API.getFormData(
            ENTITYNAME.Transmissions,
            currentUserId
        );

        setDataColumns(columns ?? []);
    };

    const handleTabChange = (event, newValue) => {
        setTabNumber(`${newValue}`);
    };

    const isValid = () => {
        if (dataItem.fromDate == undefined || dataItem.fromDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
            return false;
        }
        if (dataItem.toDate == undefined || dataItem.toDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
            return false;
        }
        if (dataItem.toDate < dataItem.fromDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_grater_then_from_date_error_message });
            return false;
        }
        return true
    }

    const loadData = async () => {
        if (!isValid()) return;
        setIsLoading(true);
        setLoadingStatus(lang.data_loading_error_message);
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columns = await API.getFormData(ENTITYNAME.Transmissions, currentUserId);
        setDataColumns(columns ?? []);
        setTransmissionData([]);
        setThumbnailData([]);
        setPendingTransmissionData([]);
        setSelectedItems([]);
        setSelectedState({});

        const payload = {
            fromDate: dataItem?.fromDate ? utility.convertStringDatetoMilliseconds(dataItem.fromDate) : null,
            toDate: dataItem?.toDate ? utility.convertStringEndDateToMilliSeconds(dataItem.toDate) : null,
            isExport: false,
            hasNoTransmission: dataItem.hasNoTransmission,
            isTxReady: dataItem.isTxReady
        };

        const res = await API.getVodActivityReport(payload);
        if (res.success) {

            setTransmissionData(res?.data?.transmissionData ?? []);
            setThumbnailData(res?.data?.thumbnailData ?? []);
            setPendingTransmissionData(res?.data?.pendingTransmissionData ?? []);
            setLoadingStatus(lang.no_record_found_error_message);
        } else {
            setTransmissionData([]);
            setThumbnailData([]);
            setPendingTransmissionData([]);
            setSelectedItems([]);
            setSelectedState({});
            setLoadingStatus(lang.no_record_found_error_message);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setIsLoading(false);
    };

    const downloadExcel = async () => {
        if (!isValid()) return;
        setIsDownloading(true);

        let columns = dataColumns;
        if (!columns || columns.length === 0) {
            let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
            columns = await API.getFormData(ENTITYNAME.Transmissions, currentUserId);
            columns = columns ?? [];
            setDataColumns(columns);
        }
        let payload = {
            fromDate: dataItem?.fromDate ? utility.convertStringDatetoMilliseconds(dataItem.fromDate) : null,
            toDate: dataItem?.toDate ? utility.convertStringEndDateToMilliSeconds(dataItem.toDate) : null,
            isExport: true,
            hasNoTransmission: dataItem.hasNoTransmission,
            isTxReady: dataItem.isTxReady,
            columns: columns.map(col => ({ name: col.name, label: col.label, type: col.type, format: col.format }))
        }
        var res = await API.getVodActivityReport(payload);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setIsDownloading(false);
    }

    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({ event, selectedState: selectedState, dataItemKey: DATA_ITEM_KEY });
        setSelectedState(newSelectedState);
        let items = transmissionData.filter((x) => newSelectedState[x._id] === true);
        setSelectedItems(items);
    }

    const onHeaderSelectionChange = (event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);
        let items = checked ? transmissionData : [];
        setSelectedItems(items);
    }
    
    const markAsVerified = async (dataItems = []) => {
        const items = Array.isArray(dataItems) ? dataItems : [dataItems];
        const currentTime = new Date().getTime();

        const payload = items.map(item => ({
            _id: item._id,
            Verified: true,
            VerifiedBy: { _id: userData?._id ?? "", Name: userData?.name ?? userData?.Name ?? "" },
            VerifiedOn: currentTime
        }));

        let res = await API.saveData(ENTITYNAME.Transmissions, payload);

        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.marked_as_verified_success_message });
            const updatedIds = items.map(x => x._id);
            setTransmissionData(transmissionData.map(x => updatedIds.includes(x._id) ? { ...x, Verified: true, VerifiedBy: { _id: userData?._id ?? "", Name: userData?.name ?? userData?.Name ?? "" }, VerifiedOn: currentTime } : x));
            const updatedData = items.filter(x => updatedIds.includes(x._id));
            for (const item of updatedData) {
                item.Verified = true;
                item.VerifiedBy = { _id: userData?._id ?? "", Name: userData?.name ?? userData?.Name ?? "" };
                item.VerifiedOn = currentTime;
                let logData = { event: LOGEVENT.UPDATE_TRANSMISSION, module: MODULE.TRANSMISSION_BROWSER, data: item, message: "Transmission updated successfully" };
                await API.SaveLogs(logData);
            }
            setSelectedItems([]);
            setSelectedState({});
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const resetVerifiedStatus = async (dataItems = []) => {
        const items = Array.isArray(dataItems) ? dataItems : [dataItems];
        const payload = items.map(item => ({
            _id: item._id,
            Verified: false,
            VerifiedBy: "",
            VerifiedOn: ""
        }));

        let res = await API.saveData(ENTITYNAME.Transmissions, payload);

        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.reset_verified_status_success_message });
            const updatedIds = items.map(x => x._id);
            setTransmissionData(transmissionData.map(x => updatedIds.includes(x._id) ? { ...x, Verified: false, VerifiedBy: "", VerifiedOn: "" } : x));
            let updatedData = items.filter(x => updatedIds.includes(x._id));
            for (const item of updatedData) {
                item.Verified = false;
                item.VerifiedBy = "";
                item.VerifiedOn = "";
                let logData = { event: LOGEVENT.UPDATE_TRANSMISSION, module: MODULE.TRANSMISSION_BROWSER, data: item, message: "Transmission updated successfully" };
                await API.SaveLogs(logData);
            }
            setSelectedItems([]);
            setSelectedState({});
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const MyCommandCell = (props) => (
        <MenuCommandCell
            {...props}
            myMenuModel={collectionMenuModelVODReport}
            markAsVerified={markAsVerified}
            resetVerifiedStatus={resetVerifiedStatus}
        />
    );
    
    const menuModel = [
        selectedItems.length > 1 && {
            label: lang.mark_as_verified_label,
            icon: 'pi pi-check-circle',
            command: () => markAsVerified(selectedItems)
        },
        selectedItems.length > 1 && {
            label: lang.reset_verified_status_label,
            icon: 'pi pi-times-circle',
            command: () => resetVerifiedStatus(selectedItems)
        }
    ].filter(Boolean);

    const actionStatusCell = (props) => {
        const { dataItem } = props;

        let title = utility.getKeyByValue(TRANSMISSION_ACTION, dataItem?.action);
        let tileBackColor = "";
        let titleColor = "white";

        switch (dataItem?.action) {
            case TRANSMISSION_ACTION.Published:
                title = title;
                tileBackColor = "#63AA43";
                break;
            case TRANSMISSION_ACTION.Delete:
                title = title;
                tileBackColor = "#E72929";
                break;
            case TRANSMISSION_ACTION.Create:
                title = title;
                tileBackColor = "#3B82F6";
                break;
            case TRANSMISSION_ACTION.Update:
                title = title;
                tileBackColor = "#F8A506";
                titleColor = "black";
                break;
        }
        return (<MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />);
    };

    const transmissionStatusCell = (props) => {
        const { dataItem } = props;

        let title = utility.getKeyByValue(TRANSMISSION_ACTIVE_STATUS, dataItem?.status);
        let tileBackColor = "";
        let titleColor = "white";
        switch (dataItem?.status) {
            case TRANSMISSION_ACTIVE_STATUS.Active:
                title = title;
                tileBackColor = "#63AA43";
                break;
            case TRANSMISSION_ACTIVE_STATUS.InActive:
                title = title;
                tileBackColor = "#E72929";
                break;
            case TRANSMISSION_ACTIVE_STATUS.Upcoming:
                title = title;
                tileBackColor = "#F8A506";
                titleColor = "black";
                break;
        }
        return (
            <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />
        );
    };

    const thumbnailStatusCell = (props) => {
        const { dataItem } = props;

        let title = dataItem?.IsThumbnailProcessed ? "Processed" : "Pending";
        let tileBackColor = dataItem?.IsThumbnailProcessed ? "#63AA43" : "#E72929";
        let titleColor = "white";

        return (<MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />);
    };

    const mamHyperLinkCell = (props) => {
        const value = utility.getDataInsideObject(props.dataItem, props.field);
        return (
            <td>
                <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => window.open(`/home/mamAssets?mamID=${value}`, '_blank')}>{value}</div>
            </td>
        )
    }

    const workingTitleHyperLinkCell = (props) => {
        const value = utility.getDataInsideObject(props.dataItem, props.field);
        const title = (value || "").replace(/\[.*$/, "").split(/\s\bS\d+\b|\s\bEp\.?\s*\d+\b/i)[0].replace(/-\s*$/, "").trim();
        return (
            <td title={value}>
                <div style={{ color: 'blue', cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => window.open(`/home/versionBrowser?searchtext=${title}`, '_blank')}>
                    {value}
                </div>
            </td>
        )
    }

    const dealReferenceHyperLinkCell = (props) => {
        const value = utility.getDataInsideObject(props.dataItem, props.field);
        return (
            <td title={value}>
                <div style={{ color: 'blue', cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => window.open(`/home/versionBrowser?searchtext=${value}`, '_blank')}>
                    {value}
                </div>
            </td>
        )
    }

    const verifiedStatusCell = (props) => {
        const { dataItem } = props;

        let title = dataItem?.Verified ? "Verified" : "Pending Verification";
        let tileBackColor = dataItem?.Verified ? "#63AA43" : "#727B84";
        let titleColor = "white";

        return (
            <MyStatusCell
                {...props}
                title={title}
                tileBackColor={tileBackColor}
                titleColor={titleColor}
            />
        );
    };

    return (<>
        <h1 className="page-title txt-color-bludeDark">
            <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
            ></i>
            <span>{lang.vod_activity_report_header}</span>
        </h1>
        <div className="row m-1">
            <div className="col-12">
                <div className="row">
                    <div className="col-3">
                        <label className="form-label">{lang.from_date_label} *</label>
                        <input type="date" className="form-control form-control-sm" name="fromDate" value={dataItem.fromDate} onChange={onChange} />
                    </div>
                    <div className="col-3">
                        <label className="form-label">{lang.to_date_label} *</label>
                        <input type="date" className="form-control form-control-sm" name="toDate" value={dataItem.toDate} onChange={onChange} />
                    </div>
                    {tabNumber === "3" && (
                        <>
                            <div className="col-auto mt-4">
                                <div className="form-check mt-1">
                                    <input className="form-check-input" type="checkbox" name="hasNoTransmission" id="hasNoTransmission" checked={dataItem.hasNoTransmission} onChange={onChange} />
                                    <label className="form-check-label" htmlFor="hasNoTransmission">
                                        {lang.has_zero_transmissions_label}
                                    </label>
                                </div>
                            </div>
                            <div className="col-auto mt-4">
                                <div className="form-check mt-1">
                                    <input className="form-check-input" type="checkbox" name="isTxReady" id="isTxReady" checked={dataItem.isTxReady} onChange={onChange} />
                                    <label className="form-check-label" htmlFor="isTxReady">
                                        {lang.tx_ready_label}
                                    </label>
                                </div>
                            </div>
                        </>
                    )}
                    <div className="col mt-4">
                        <ActionButton name={lang.show_button_text} onClick={loadData} isLoading={isLoading} />
                        <RoundButton icon='download' onClick={() => downloadExcel()} disabled={isDownloading} isLoading={isDownloading} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Box sx={{ width: "100%" }}>
                            <TabContext value={tabNumber}>
                                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                    <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                        <Tab label={`${lang.transmissions_label} (${transmissionData.length})`} value="1" />
                                        <Tab label={`${lang.thumbnails_label} (${thumbnailData.length})`} value="2" />
                                        <Tab label={`${lang.pending_transmissions_label} (${pendingTransmissionData.length})`} value="3" />
                                    </TabList>
                                </Box>
                                <TabPanel value="1">
                                    <Grid
                                        style={{ height: '67vh', overflow: 'auto' }}
                                        resizable={true}
                                        data={transmissionData.map(item => ({ ...item, selected: !!selectedState[item._id] }))}
                                        selectedField="selected"
                                        onSelectionChange={onSelectionChange}
                                        onHeaderSelectionChange={onHeaderSelectionChange}
                                        dataItemKey={DATA_ITEM_KEY}
                                    >
                                        <GridNoRecords>{loadingStatus}</GridNoRecords>
                                            <GridToolbar>
                                                <div className="d-flex">
                                                    {selectedItems.length > 1 && (
                                                    <div>
                                                        <RoundButton icon="ellipsis-v" title={lang.context_menu_label} onClick={(e) => menuRef.current.show(e)} />
                                                        <ContextMenu
                                                            ref={menuRef}
                                                            model={menuModel}
                                                        />
                                                    </div>
                                                )}
                                                </div>
                                            </GridToolbar>
                                        <GridColumn cell={MyCommandCell} width={"60px"} locked={true} resizable={false} />
                                        <GridColumn
                                            field="selected"
                                            width="50px"
                                            headerSelectionValue={
                                                transmissionData.length > 0 && transmissionData.findIndex(item => !selectedState[item._id]) === -1
                                            }
                                            locked={true}
                                        />
                                        {dataColumns.map((column, index) => {
                                            if (column.type === COLUMNSTYPE.date) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={DateOnlyCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={true}
                                                    />
                                                );
                                            } else if (column.type === COLUMNSTYPE.datetime) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={DateCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={true}
                                                    />
                                                );
                                            } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={TimeCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={true}
                                                    />
                                                );
                                            } else if (column.name === "SID") {
                                                return;
                                            }
                                            else if (column.type === COLUMNSTYPE.array) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={ArrayCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        format={column.format ?? "Description"}
                                                        sortable={false}
                                                    />
                                                );
                                            }
                                            else if (column.type === COLUMNSTYPE.transmissionTypeStatus) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={TransmissionTypeStatusCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={false}
                                                    />
                                                );
                                            }
                                            else if (column.label === "Title") {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        format={column.format}
                                                        sortable={false}
                                                    />
                                                );
                                            }
                                            else if (column.type === COLUMNSTYPE.mamStatus) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={MAMStatusCell}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={false}
                                                    />
                                                );
                                            }
                                            else if (column.type === COLUMNSTYPE.localdatetime) {
                                                return (
                                                    <GridColumn
                                                        key={index}
                                                        field={column.name}
                                                        cell={LocalDateTimeColumn}
                                                        title={column.label}
                                                        width={column.width ?? 200}
                                                        sortable={false}
                                                    />
                                                );
                                            }
                                            else if (column.label === "MAM ID") {
                                                return (
                                                    <GridColumn
                                                        field={column.name}
                                                        title={column.label}
                                                        cell={mamHyperLinkCell}
                                                        width={column.width ?? 120}
                                                        sortable={false}
                                                    />
                                                )
                                            }
                                            else if (column.name === "status") {
                                                return (
                                                    <GridColumn
                                                        field={column.name}
                                                        title={column.label}
                                                        cell={transmissionStatusCell}
                                                        width={column.width ?? 120}
                                                        sortable={false}
                                                    />
                                                )
                                            }
                                            else if (column.name === "action") {
                                                return (
                                                    <GridColumn
                                                        field={column.name}
                                                        title={column.label}
                                                        cell={actionStatusCell}
                                                        width={column.width ?? 120}
                                                        sortable={false}
                                                    />
                                                )
                                            }
                                            else if (column.name === "IsThumbnailProcessed") {
                                                return (
                                                    <GridColumn
                                                        field={column.name}
                                                        title={column.label}
                                                        cell={thumbnailStatusCell}
                                                        width={column.width ?? 130}
                                                        sortable={false}
                                                    />
                                                )
                                            }
                                            else if (column.name === "Verified") {
                                                return (
                                                    <GridColumn
                                                        field={column.name}
                                                        title={column.label}
                                                        cell={verifiedStatusCell}
                                                        width={column.width ?? 130}
                                                        sortable={false}
                                                    />
                                                )
                                            }
                                            else {
                                                return (
                                                    column.type !== COLUMNSTYPE.hidden && (
                                                        <GridColumn
                                                            key={index}
                                                            field={column.name}
                                                            title={column.label}
                                                            width={column.width ?? 200}
                                                            sortable={true}
                                                        />
                                                    )
                                                );
                                            }
                                        })}
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="2">
                                    <Grid data={thumbnailData} style={{ height: '60vh' }} resizable={true}>
                                        <GridNoRecords>{loadingStatus}</GridNoRecords>
                                        <GridColumn field="CSID" title={lang.transmission_id_column} width={"150"} />
                                        <GridColumn field="title" title={lang.title_column} width={"180"} />
                                        <GridColumn field="episodeNumber" title={lang.episode_number_label} width={"140"} />
                                        <GridColumn field="contentId" title={lang.content_id_column} width={"150"} />
                                        <GridColumn field="MamAssetId" title={lang.mamID_label} width={"150"} />
                                        <GridColumn field="IsThumbnailProcessed" title={lang.thumbnail_status_column} width={"150"} cell={thumbnailStatusCell} />
                                        <GridColumn field="thumbnailFilename" title={lang.thumbnail_filename_column} width={"220"} />
                                        <GridColumn field="thumbnailProcessedOn" title={lang.thumbnail_process_on_column} width={"200"} />
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="3">
                                    <Grid data={pendingTransmissionData} style={{ height: '60vh' }} resizable={true}>
                                        <GridNoRecords>{loadingStatus}</GridNoRecords>
                                        <GridColumn field="DealReference" title={lang.deal_reference_label} width={"150"} cell={dealReferenceHyperLinkCell} />
                                        <GridColumn field="WorkingTitle" title={lang.working_title_column} cell={workingTitleHyperLinkCell} />
                                        <GridColumn field="EpisodeNumber" title={lang.episode_number_column} width={"120"} />
                                        <GridColumn field="PublishStartDate" title={lang.publish_start_date_label} cell={DateOnlyCell} width={"140"} />
                                        <GridColumn field="PublishEndDate" title={lang.publish_end_date_label} cell={DateOnlyCell} width={"140"} />
                                        <GridColumn field="MamAssetId" title={lang.mamID_label} width={"150"} />
                                        <GridColumn field="MamStatus" title={lang.mam_asset_status_column} cell={MAMStatusCell} width={"170"} />
                                        <GridColumn field="TransmissionCount" title={lang.transmission_count_column} width={"150"} />
                                    </Grid>
                                </TabPanel>
                            </TabContext>
                        </Box>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default VODActivityReport;